module.exports = __webpack_public_path__ + "media/img/about/social/instagram-97e08f00fdeb37eb6ff2d06e73f43509.png";